import { InformationGridItemData } from "../../Unknown/InformationGridItem/types";

const getInformationGridItems = (params: {
  phoneNumber?: {
    url: string;
    styled: string;
  };
  additionalPhoneNumber?: {
    url: string;
    styled: string;
  };
  email?: string;
  patients: {
    id: string;
    firstName: string;
    lastName: string;
    onClick: () => void;
  }[];
  familyMembers?: {
    id: string;
    firstName: string;
    lastName: string;
    onClick: () => void;
  }[];
  translations: {
    labelPhoneNumber: string;
    labelEmail: string;
    labelPatients: string;
    labelFamilyMembers: string;
  };
}) => {
  const {
    phoneNumber,
    additionalPhoneNumber,
    email,
    patients,
    familyMembers,
    translations,
  } = params;

  const result: ({ id: string } & InformationGridItemData)[] = [];

  if (phoneNumber) {
    if (additionalPhoneNumber) {
      result.push({
        id: "phoneNumber",
        type: "linkList",
        label: translations.labelPhoneNumber,
        linkList: [
          { text: phoneNumber.styled, href: `tel:${phoneNumber.url}` },
          {
            text: additionalPhoneNumber.styled,
            href: `tel:${additionalPhoneNumber.url}`,
          },
        ],
      });
    } else {
      result.push({
        id: "phoneNumber",
        type: "link",
        label: translations.labelPhoneNumber,
        text: phoneNumber.styled,
        href: `tel:${phoneNumber.url}`,
      });
    }
  }

  if (email) {
    result.push({
      id: "email",
      type: "link",
      label: translations.labelEmail,
      text: email,
      href: `mailto:${email}`,
    });
  }

  if (patients?.length) {
    result.push({
      id: "patients",
      type: "clickList",
      label: translations.labelPatients,
      clickList: patients?.map((patient) => ({
        id: patient.id,
        text: `${patient.lastName}, ${patient.firstName}`,
        onClick: patient.onClick,
      })),
    });
  }

  if (familyMembers?.length) {
    result.push({
      id: "familyMembers",
      type: "clickList",
      label: translations.labelFamilyMembers,
      clickList: familyMembers.map((fm) => ({
        id: fm.id,
        text: `${fm.lastName}, ${fm.firstName}`,
        onClick: fm.onClick,
      })),
    });
  }

  return result;
};

export default getInformationGridItems;
